import React, { useEffect, useState } from 'react';
import { instanceOf } from 'prop-types';
import { withRouter, browserHistory } from 'react-router';
import BuildView from '../../components/enablement/BuildView';
import { useDispatch } from '../../components/react-redux-hooks';
import {
  isDataContains,
  setEditTargetNode,
  setTempSelectedTargetForBuild } from '../../actions/deActions/deBuildActions';

const Build = (props) => {
  let navConfirmed = false;
  const [routerLeaveModal, setRouterLeaveModal] = useState(false);
  const [nextLocation, setNextLocation] = useState('');
  const dispatch = useDispatch();

  const confirmNavigation = () => {
    navConfirmed = true;
    setRouterLeaveModal(false);
    browserHistory.push(nextLocation);
  };

  const resetRouterLocation = () => {
    setRouterLeaveModal('');
    setNextLocation('');
  };

  const routerWillLeave = nextLocation => {
    const hasUnsavedChanges = dispatch(isDataContains());
    if (hasUnsavedChanges && !navConfirmed) {
      setNextLocation(nextLocation.pathname);
      setRouterLeaveModal(true);
      dispatch(setTempSelectedTargetForBuild(null));
      return false;
    }
    navConfirmed = false;
    dispatch(setEditTargetNode(null))
    dispatch(setTempSelectedTargetForBuild(null))
    return true;
  };

  useEffect(() => {
    // method to prompt user on leaving module for unsaved changes
    props.router.setRouteLeaveHook(props.route, routerWillLeave);
  }, []);

  return (
    <React.Fragment>
      <BuildView
        resetRouterLocation={resetRouterLocation}
        routerLeaveModal={routerLeaveModal}
        confirmNavigation={confirmNavigation}
      />
    </React.Fragment>
  );
};

Build.propTypes = {
  router: instanceOf(Object),
  route: instanceOf(Object),
};

export default withRouter(Build);
